import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import BottomMessagePopUp from "../../../components/BottomMessagePopUp";
import { Dropdown } from "primereact/dropdown";
import { useTranslation } from "react-i18next";

const AddOnDrivers = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const { t } = useTranslation();

	const [errorMessage, setErrorMessage] = useState("");
	const [isErrorVisible, setIsErrorVisible] = useState(false);

	const selectedAddOn = location.state?.addOn;

	// const initialPlan =
	// 	JSON.parse(localStorage.getItem("plan_code")) ||
	// 	JSON.stringify({ name: "Plan A", code: "Plan A" });

	const [selectedPlan, setSelectedPlan] = useState({name: "CART 7 DAYS @ RM50.00/DAY", code: '7x50'});
	const plans = [
		{ name: "CART 7 DAYS @ RM50.00/DAY", code: "7x50", si: "350", sum_insured: "350", unit: "7", amount: "50.00" },
		{ name: "CART 7 DAYS @ RM100.00/DAY", code: "7x100", si: "700", sum_insured: "700", unit: "7", amount: "100.00" },
		{ name: "CART 7 DAYS @ RM200.00/DAY", code: "7x200", si: "1400", sum_insured: "1400", unit: "7", amount: "200.00" },
		{ name: "CART 14 DAYS @ RM50.00/DAY", code: "14x50", si: "700", sum_insured: "700", unit: "14", amount: "50.00" },
		{ name: "CART 14 DAYS @ RM100.00/DAY", code: "14x100", si: "1400", sum_insured: "1400", unit: "14", amount: "100.00" },
		{ name: "CART 14 DAYS @ RM200.00/DAY", code: "14x200", si: "2800", sum_insured: "2800", unit: "14", amount: "200.00" },
		{ name: "CART 21 DAYS @ RM50.00/DAY", code: "21x50", si: "1050", sum_insured: "1050", unit: "21", amount: "50.00" },
		{ name: "CART 21 DAYS @ RM100.00/DAY", code: "21x100", si: "2100", sum_insured: "2100", unit: "21", amount: "100.00" },
		{ name: "CART 21 DAYS @ RM200.00/DAY", code: "21x200", si: "4200", sum_insured: "4200", unit: "21", amount: "200.00" },
	];

	useEffect(() => {
		console.log('selected lonpac cart', selectedPlan)
		localStorage.setItem("cart_selection", JSON.stringify(selectedPlan));
	}, [selectedPlan]);

	if (!selectedAddOn) {
		return (
			<div className="content">
				<h3>{t(`autoInsurance.addOnSumInsured.noAddOnSelected`)}</h3>
				<Button label={t(`autoInsurance.addOnSumInsured.goBack`)} onClick={() => navigate(-1)} />
			</div>
		);
	}

	const handleReturnClick = (e) => {
		e.preventDefault();
		const queryParameters = new URLSearchParams(window.location.search);
		const policyId = queryParameters.get("policy_id");

		navigate(
			policyId
				? `/get-quote/add-on-others?policy_id=${policyId}`
				: `/get-quote/add-on-others`,
			{
				replace: true,
				state: {
					...selectedAddOn,
					selectedPlan, // Pass the sum_insured value here
				},
			}
		);
	};

	return (
		<div className="content">
			<div className="get-quote-container">
				<h3>{`${selectedAddOn.title}`}</h3>

				<div className="add-on-details border-radius-10 w-100 mb-8rem">
					<Dropdown
						value={selectedPlan}
						onChange={(e) => setSelectedPlan(e.value)}
						options={plans}
						optionLabel="name"
						placeholder={t(`autoInsurance.loapacCart.selectAnOption`)}
						className="w-full md:w-14rem"
					/>
				</div>

				<div className={`sticky-bottom `}>
					<div className="d-flex flex-row flex-wrap justify-content-between align-items-center">
						{/* Selected Plan and Logo Section */}
						<div className="plan-details">
							<span className="text-left formatted-text">
							{t(`autoInsurance.addOnSumInsured.selectingAddOnsFor`)}
							</span>
							<br />
							<span className="fw-bold color-heading">
								{selectedAddOn.title}
							</span>
							<p className="my-0 fw-bold insurer-name"></p>
						</div>
						<div className="col-sm-6 w-50"></div>
					</div>
					<hr />
					<Button
						label={t(`autoInsurance.addOnsOther.returnAddOns`)}
						className="btn-primary"
						onClick={(e) => handleReturnClick(e)}
					/>
					<BottomMessagePopUp
						message={errorMessage}
						type="error"
						isVisible={isErrorVisible}
						onClose={() => setIsErrorVisible(false)}
					/>
				</div>
			</div>
		</div>
	);
};

export default AddOnDrivers;
